/**
 * Single source of truth for CDN responsive image widths.
 *
 * Every consumer that builds or generates `-<width>w.<ext>` variant URLs must
 * import this list: the client srcSet builders (responsive-image.js,
 * MultiFormatImage.js, CroppedImage.js), the static-asset generation pipeline
 * (scripts/image-config.mjs) and the post-cover pipeline
 * (post-image-variants.mjs, scripts/backfill-post-variants.mjs).
 *
 * IMPORTANT: a width listed here is only valid if the matching
 * `-<width>w.webp` objects actually exist on the CDN for every asset that gets
 * a srcSet. Adding a width without generating and uploading the variants makes
 * the browser request a missing object, which shows up as a broken image and
 * (in Firefox) an OpaqueResponseBlocking console error.
 *
 * 400w  = small cards / small mobile
 * 800w  = tablet / mobile retina
 * 1200w = laptop / tablet retina
 * 1920w = desktop / retina
 */
export const RESPONSIVE_WIDTHS = [400, 800, 1200, 1920];
